<template>
	<div class="register">
		<div class="logo">
			<img src="../../assets/images/User/logo.png" alt="">
		</div>
		<div class="registerForm">
			<van-cell-group>
			  <van-field v-model="formData.mobile" placeholder="请输入手机号" clearable />
			</van-cell-group>
			<van-cell-group>
			  <van-field v-model="formData.code" placeholder="请输入验证码" clearable />
			  <button @click="sendCode">{{sendTimeText}}</button>
			</van-cell-group>
			<button class="registerBtn" @click="bindMobile" :disabled="canclick">绑定</button>	
		</div>

		<div class="tip" ref="tip">专注血管外科领域宣传与继续教育新媒体</div>
	</div>
</template>
<script>
import {SendCode,GetUserInfo,BindMobile} from '../../config/interface.js'
import { Dialog } from "vant";

	let codeTimer;
	export default{
		data(){
			return{
				sendTimeText:'获取验证码',
				formData:{
					mobile:'',
					code:'',
					pwd:'',
					repwd:''
				},
				countdown:60,
				isReSend:true,     //能否再次点击发送验证码
				canclick:false,
			}
		},
		mounted(){
			let screenHeight = document.documentElement.clientHeight;
			window.onresize=()=>{
				if(screenHeight>document.documentElement.clientHeight){
					this.$refs.tip.style.position='static';
				}else{
					this.$refs.tip.style.position='absolute';
				}
			}

			console.log(common.getUrlKey('callback_url'))
		},
		methods:{
			//验证手机号
			verifyMobile(){
				let mobile=this.formData.mobile;
				if(mobile==''){
					common.toast('请输入手机号',1000)
				}else if(!(/^1[3456789]\d{9}$/.test(mobile))){
					common.toast('请输入正确手机号',1000)
				}else{
					return true;
				}
				return false;
			},
			//点击发送验证码
			sendCode(){
				if(this.isReSend&&this.verifyMobile()){
					this.getCode();
					this.isReSend=false;
				}
			},
			//得到验证码
			getCode(mobile){
				this.sendTime();
				const url=SendCode;
				const method='POST';
				let params={
					mobile:this.formData.mobile
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
                        common.toast('发送成功',1000);
					}else{
						console.log('注册')
					}
				})

			},
			sendTime(){
					codeTimer=setTimeout(()=>{
						if(this.countdown==1){
							this.clearCodeTimer();
							return;							
						}else{
							this.countdown--;
							this.sendTimeText='重新发送('+this.countdown+')s';
							setTimeout(this.sendTime(), 1000);
						}
				  	}, 1000)
			},
			//清除定时器
			clearCodeTimer(){
				clearTimeout(codeTimer);
				this.isReSend=true;
				this.sendTimeText="获取验证码";
				this.countdown=60;
			},
			//验证表单
			verifyForm(){
					if(!this.verifyMobile()){

					}else if(this.formData.code==''){
						common.toast('请输入验证码',1000)
					}else{
						return true;
					}
					return false;
			},
			//绑定手机号
			bindMobile(){
				if(this.verifyForm()){
					this.canclick=true;
					const url=BindMobile;
					const method='POST'
					let params={
						mobile:this.formData.mobile,
						msgcode:this.formData.code,
					}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							common.toast('绑定成功',1000,'success',()=>{
								this.getUserInfo();
							})
						}
						else{
							if (res.code == 901) {
								Dialog.confirm({
									message: "您的账号已在PC端注册过，是否强制合并账号？",
									})
								.then(() => {
									const url=BindMobile;
									const method='POST'
									let params={
										mobile:this.formData.mobile,
										msgcode:this.formData.code,
										merge_account: 1,
									};
									fetch(url, params, method).then((res) => {
										if (res.code == 0) {
											common.toast("绑定成功", 1000, "success", () => {
												this.getUserInfo();
											});
										} 
									});
								})
							}
							else{
								this.canclick=false;
							}
						}
								
					})
				}
            },
           //获取用户信息
			getUserInfo(){
				const url=GetUserInfo;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						localStorage.setItem('userInfo',JSON.stringify(data));
           				this.$store.dispatch('storageUserInfo',data);
						let callback_url=common.getUrlKey('callback_url')?decodeURI(common.getUrlKey('callback_url')):null;
						if(callback_url){
								window.location.href=callback_url;
						}else{
								this.$router.push({
									path:'/'
								})
						}
					}
				})
			}


		}
	}
</script>
<style lang="scss" scoped>
	.register{
		width:100%;
		height:100%;
		position:relative;
		.logo{
			padding:38px 0;
			text-align:center;
			img{
				width:80%;
			}
		}
		.registerForm{
			.van-cell-group{
				
				width:295px;
				height:44px;
				box-sizing:border-box;
				margin:0 auto;
				margin-bottom:20px;
				@include flex(row);
				align-items:center;
				border: 1px solid #D3D3D3;
				border-radius: 23px;
				padding-left:15px;
				padding-right:5px;
				.van-cell{
					padding:0px 10px;
					background:transparent;
					input{
						height:44px;
					}
					input::-webkit-input-placeholder{
						color:#ababab;
						font-size:14px;
					}
				}
				button{
					width:140px;
					border:0px;
					color:$color-main;
					background:#fff;
					border-left:1px solid $color-main;
				}
			}
			.van-cell-group:after{
					border:0px;
				}
			.registerBtn{
				display:block;
				margin:40px  auto;
				width:295px;
				height:44px;
				background: #901d22;
				font-size:17px;
				color:#fff;
				border:0px;
				border-radius:23px;
			}			
		}
		.operation{
			width:180px;
			margin:20px auto;
			@include flex(row);
			justify-content: space-around;
			align-items:center;
			a{
				color:#666;
				font-size:14px
			}
		}
		.tip{
			position:absolute;
			bottom:20px;
			width:100%;
			text-align:center;
			font-size:13px;
			color:$color-main;
			letter-spacing:.5px;
		}		
	}
</style>


// WEBPACK FOOTER //
// src/pages/User/bindMobile.vue